import { useEffect, useState } from 'react'

import { detectOS, OSName } from '../lib/detectOs'

export type { OSName }

export function useDetectOs() {
  const [os, setOS] = useState<OSName | 'Loading'>('Loading')

  useEffect(() => {
    detectOS().then((os) => {
      setOS(os)
    })
  }, [])

  return os
}
